import React, { forwardRef } from 'react'
import { Link as BaseLink } from 'react-router-dom'
import { Grid as BaseGrid, TableContainer as BaseTableContainer, styled } from '@mui/material'
import {
  Card as BaseCard,
  InfoIcon as BaseInfoIcon,
  TableCell as BaseTableCell,
  Tooltip as BaseTooltip
} from '@chilecompra/react-kit/components'

export const BaseContainer = styled(forwardRef((props, ref) => <BaseGrid container ref={ref} {...props} />))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Bold = styled('strong')`
  font-weight: bolder;
`

export const Box = styled(
  ({
    alignItems,
    children,
    display,
    flexDirection,
    flexWrap,
    gap,
    justifyContent,
    padding,
    paddingLeft,
    width,
    ...props
  }) => <div {...props}>{children}</div>
)`
  align-items: ${props => props.alignItems};
  display: ${props => props.display};
  flex-direction: ${props => props.flexDirection};
  flex-wrap: ${props => props.flexWrap};
  gap: ${props => props.gap};
  justify-content: ${props => props.justifyContent};
  padding-left: ${props => props.paddingLeft};
  padding: ${props => props.padding};
  width: ${props => props.width};
`

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  text-align: ${props => props.textAlign};
`

export const Column = styled(({ flexGrow, margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-grow: ${props => props.flexGrow ?? ''};
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
    width: ${props => props.width};
  }

  &.MuiGrid-item {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
  }
`

export const Container = styled(BaseContainer)``

export const DialogButtons = styled(BaseContainer)``

export const DialogContent = styled(BaseContainer)`
  &.MuiGrid-container {
    gap: 20px;

    ${props => props.theme.breakpoints.only('sm')} {
      padding: 32px 16px;
    }

    ${props => props.theme.breakpoints.only('xs')} {
      padding: 32px 0;
    }
  }
`

export const DialogMessage = styled(BaseContainer)`
  &.MuiGrid-container {
    gap: 18px;
  }
`

export const ForeignText = styled('span')`
  font-size: 14px;
`

export const InfoIcon = styled(BaseInfoIcon)`
  &.MuiSvgIcon-root {
    height: 0.5em;
  }
`

export const Link = styled(({ bold, children, disabled, secondary, textDecoration, ...props }) => (
  <BaseLink {...props}>{children}</BaseLink>
))`
  align-items: center;
  color: ${props => (props.secondary || props.disabled ? props.theme.palette.gray[50] : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${props => (props.bold ? 'bold' : '400')};
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: ${props => (props.textDecoration ? 'underline' : 'none')};

  &:hover {
    color: ${props => (props.secondary ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
    text-decoration: underline;
  }
`

export const Logo = styled('img')`
  border-radius: 50%;
  height: 73px;
  width: 73px;
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.gray[50]};
  height: auto;
  width: 82px;
`

export const Strong = styled('strong')`
  font-weight: bold;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`

export const TableContainer = styled(BaseTableContainer)``

export const TextSpacer = styled('hr')`
  margin: 0.5rem 0;
  border: none;
`

export const Tooltip = styled(BaseTooltip)`
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    max-height: 100%;
    max-width: 54ch;

    & > div {
      max-height: 100%;
    }
  }
`
export const TooltipContainer = styled('div')`
  align-items: center;
  display: flex;
`

export const TooltipIcon = styled('span')`
  align-items: center;
  display: flex;
  margin-left: 4px;
`
